import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { API_BASE } from '../../config';
import { ADMIN_FILTER_CONTROL_CLASSNAME } from './admin-ui';
import { cn } from '../../lib/utils';

export interface LLMModelOption {
  value: string;
  label: string;
  provider: string;
}

interface LLMModelSelectorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  emptyLabel?: string;
  minWidth?: string;
  className?: string;
}

export const useLLMModels = (): LLMModelOption[] => {
  const { token, masterKey, user } = useAuth();
  const [models, setModels] = useState<LLMModelOption[]>([]);

  useEffect(() => {
    const fetchModels = async () => {
      if ((!token && !masterKey) || !user?.admin) {
        return;
      }

      try {
        const url = masterKey
          ? `${API_BASE}/api/users/llm-models?masterKey=${encodeURIComponent(masterKey)}`
          : `${API_BASE}/api/users/llm-models`;
        const response = await fetch(url, {
          headers: {
            ...(token && !masterKey ? { Authorization: `Bearer ${token}` } : {}),
          },
        });

        if (response.ok) {
          const data = await response.json();
          setModels(data.models || []);
        }
      } catch (err) {
        console.error('Error fetching LLM models:', err);
      }
    };

    fetchModels();
  }, [token, masterKey, user]);

  return models;
};

export const LLMModelSelector: React.FC<LLMModelSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  emptyLabel = 'Sin fijar (usar reglas normales)',
  minWidth,
  className,
}) => {
  const models = useLLMModels();

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      style={minWidth ? { minWidth } : undefined}
      className={cn(
        ADMIN_FILTER_CONTROL_CLASSNAME,
        'max-w-full',
        className,
        disabled && 'cursor-not-allowed opacity-50',
      )}
    >
      <option value="">{emptyLabel}</option>
      {models.map((model) => (
        <option key={model.value} value={model.value}>
          {model.label}
        </option>
      ))}
    </select>
  );
};

